module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-table-msg-center"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "class-name": "border-right-column",
      "prop": "index",
      "align": "left",
      "label": "",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "消息标题",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          staticClass: "message-title new_icon",
          attrs: {
            "href": "javascript:void(0);"
          },
          on: {
            "click": function($event) {
              _vm.showDetail(scope.row)
            }
          }
        }, [_vm._v("\n          " + _vm._s(scope.row.title.length > 36 ? scope.row.title.slice(0, 35) + '...' : scope.row.title) + "\n          "), (!scope.row.is_read) ? _c('img', {
          staticClass: "icon-new",
          attrs: {
            "src": _vm.imgUrl,
            "alt": ""
          }
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "publish_time",
      "label": "推送日期",
      "width": "326"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('messageDialog', {
    ref: "m_dialog",
    on: {
      "close": _vm.closeDialog
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a952af2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/MessageCenter/MessageCenter.vue
// module id = 176
// module chunks = 0